import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues, submit, isDirty, isValid } from 'redux-form';

import { Main } from 'Containers/';
import { PowerSchoolExportFieldEnum as FieldEnum } from 'Common/Constants/SISIntegration';
import { POWERSCHOOL_EXPORT_CONFIGURATION_FORM_NAME } from 'Common/FormEnum';
import { errorToast } from 'Common/ToastHelper';
import { NotificationMessage } from 'Components/';

import { PowerSchoolExportConfigurationForm } from './PowerSchoolExportConfigurationForm';
import { ExportFieldsEnum } from '../../helpers/PowerSchoolExportHelpers';
import * as PowerSchoolExportSelectors from '../../state/selectors';
import * as PowerSchoolExportActions from '../../state/actions';

class PowerSchoolExportConfigurationStepContainer extends Component {
  static stepInfo = {
    icon: 'configure',
    title: 'Configuration',
    description: 'Configure PowerSchool FTP connection settings',
  };

  componentDidMount() {
    this.props.getConfiguration();
  }

  componentDidUpdate(prevProps) {
    const {
      postSaveConfigurationResult,
      postSaveConfigurationErrors,
      clearPostSaveConfigurationResult,

      formValid,
      formDirty,

      stepCompleted,
      setStepCompleted,
    } = this.props;

    if (postSaveConfigurationResult || postSaveConfigurationErrors) {
      if (!errorToast(this.props, prevProps, 'postSaveConfigurationErrors')) {
        NotificationMessage({ Data: postSaveConfigurationResult, Errors: [] });
      }

      clearPostSaveConfigurationResult();
    }

    if (formValid && !formDirty && !stepCompleted) {
      setStepCompleted(true);
    } else if ((!formValid || formDirty) && stepCompleted) {
      setStepCompleted(false);
    }
  }

  handleSave = () => {
    this.props.submit();
  };

  handleSubmit = (values) => {
    const { postSaveConfiguration, setStepCompleted } = this.props;

    const { [FieldEnum.ExportFields]: exportFields, ...payload } = values;

    //use bitwise to separate show* fields
    payload[FieldEnum.FTPShowBalance] =
      (exportFields & ExportFieldsEnum.Balance) === ExportFieldsEnum.Balance;
    payload[FieldEnum.FTPShowStatus] =
      (exportFields & ExportFieldsEnum.Status) === ExportFieldsEnum.Status;

    postSaveConfiguration(payload);
    setStepCompleted(false, true);
  };

  getMainProps = () => {
    const {
      getConfigurationLoading,
      postSaveConfigurationLoading,
      formDirty,
      formValid,
      stepCompleted,
      goToNextStep,
    } = this.props;

    const mainProps = {
      toolbox: {
        shown: true,
        rightButtons: [
          {
            content: 'Save',
            loading: postSaveConfigurationLoading,
            disabled:
              getConfigurationLoading ||
              postSaveConfigurationLoading ||
              !formDirty ||
              !formValid,
            onClick: () => this.handleSave(),
          },
          {
            content: 'Next',
            disabled: formDirty || !stepCompleted,
            onClick: goToNextStep,
          },
        ],
      },
    };

    return mainProps;
  };

  getInitialValues = () => {
    const { getConfigurationResult } = this.props;

    let existingValues = {};

    if (getConfigurationResult) {
      existingValues = getConfigurationResult;

      //use bitwise to combine show* fields
      existingValues[FieldEnum.ExportFields] =
        (existingValues[FieldEnum.FTPShowBalance]
          ? ExportFieldsEnum.Balance
          : 0) |
        (existingValues[FieldEnum.FTPShowStatus] ? ExportFieldsEnum.Status : 0);
    }

    const initialValues = {
      [FieldEnum.ExportFields]: ExportFieldsEnum.Both,
      [FieldEnum.ExportTime]: 'YYYYYYY0000',
      ...existingValues,
    };

    return initialValues;
  };

  render() {
    const {
      getConfigurationLoading,
      postSaveConfigurationLoading,
    } = this.props;

    const mainProps = this.getMainProps();
    const initialValues = this.getInitialValues();

    return (
      <Main {...mainProps}>
        <PowerSchoolExportConfigurationForm
          initialValues={initialValues}
          onSubmit={this.handleSubmit}
          disabled={getConfigurationLoading || postSaveConfigurationLoading}
        />
      </Main>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    formValues: getFormValues(POWERSCHOOL_EXPORT_CONFIGURATION_FORM_NAME)(
      state
    ),
    formValid: isValid(POWERSCHOOL_EXPORT_CONFIGURATION_FORM_NAME)(state),
    formDirty: isDirty(POWERSCHOOL_EXPORT_CONFIGURATION_FORM_NAME)(state),

    getConfigurationLoading: PowerSchoolExportSelectors.getConfigurationLoading(
      state
    ),
    getConfigurationResult: PowerSchoolExportSelectors.getConfigurationResult(
      state
    ),
    getConfigurationErrors: PowerSchoolExportSelectors.getConfigurationErrors(
      state
    ),

    postSaveConfigurationLoading: PowerSchoolExportSelectors.postSaveConfigurationLoading(
      state
    ),
    postSaveConfigurationResult: PowerSchoolExportSelectors.postSaveConfigurationResult(
      state
    ),
    postSaveConfigurationErrors: PowerSchoolExportSelectors.postSaveConfigurationErrors(
      state
    ),
  };
};

const mapDispatchToProps = {
  getConfiguration: PowerSchoolExportActions.getConfiguration,

  postSaveConfiguration: PowerSchoolExportActions.postSaveConfiguration,
  clearPostSaveConfigurationResult:
    PowerSchoolExportActions.clearPostSaveConfigurationResult,

  submit: () => submit(POWERSCHOOL_EXPORT_CONFIGURATION_FORM_NAME),
};

export const PowerSchoolExportConfigurationStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(PowerSchoolExportConfigurationStepContainer);



// WEBPACK FOOTER //
// ./src/pages/powerschoolintegration/powerschoolexport/components/PowerSchoolExportConfigurationStep/PowerSchoolExportConfigurationStep.js